import { render } from "./PasswordResetFormApp.vue?vue&type=template&id=29b21811"
import script from "./PasswordResetFormApp.vue?vue&type=script&lang=js"
export * from "./PasswordResetFormApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__